import React from 'react';
import { Tooltip } from 'antd';

const DashboardCard = ({ 
  icon: Icon, 
  title, 
  count, 
  badge, 
  onClick,
  loading = false,
  accentColor = "#1e3a8a" // Default blue accent color
}) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-md p-5 animate-pulse">
        <div className="h-10 w-10 bg-gray-200 rounded-full mb-4"></div>
        <div className="h-5 bg-gray-200 rounded w-1/2 mb-4"></div>
        <div className="h-8 bg-gray-200 rounded w-1/4"></div>
      </div>
    );
  }

  // Don't render cards with no count value
  if (count === undefined || count === null || count === '') {
    return null;
  }

  return (
    <div 
      className="bg-white rounded-lg shadow-md p-5 border-t-4 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 cursor-pointer"
      style={{ borderColor: accentColor }}
      onClick={onClick}
    >
      <div className="flex justify-between items-center">
        <div 
          className="p-3 rounded-full" 
          style={{ backgroundColor: `${accentColor}15` }} // Very light version of the accent color (15% opacity)
        >
          <Icon 
            className="h-6 w-6" 
            style={{ color: accentColor }}
          />
        </div>
        {badge && (
          <span className="bg-red-100 text-red-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
            {badge.text}
          </span>
        )}
      </div>
      <h3 className="text-lg font-bold mt-4 text-gray-800">{title}</h3>
      <div className="flex justify-between items-end mt-1">
        <span className="text-2xl font-extrabold" style={{ color: accentColor }}>{count}</span>
        <Tooltip title={`View all ${title.toLowerCase()}`}>
          <div 
            className="p-2 rounded-full hover:bg-gray-100"
            style={{ color: accentColor }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

export default DashboardCard;